import { dbPromise } from '../db';

const FAILED_RECORDS_TABLE = 'failed_records';

export interface IFailedRecord<T = unknown> {
  id: string;
  jobId: string;
  type: 'question' | 'mocktest' | 'chapter' | 'station';
  data: T;
  timestamp: number;
  error?: string;
}

export const failedRecordsSchema = {
  name: FAILED_RECORDS_TABLE,
  keyPath: 'id',
  indexes: [
    { name: 'jobId', keyPath: 'jobId', options: { unique: false } },
    { name: 'type', keyPath: 'type', options: { unique: false } },
    { name: 'timestamp', keyPath: 'timestamp', options: { unique: false } },
  ],
};

export const API = {
  create: async <T>(record: Omit<IFailedRecord<T>, 'id' | 'timestamp'>): Promise<string> => {
    const db = await dbPromise;
    // const id = `${Date.now()}_${crypto.randomUUID()}`;
    const id = crypto.randomUUID();
    const entity: IFailedRecord<T> = {
      ...record,
      id,
      timestamp: Date.now(),
    };
    await db.put(FAILED_RECORDS_TABLE, entity);
    return id;
  },

  getById: async <T>(id: string): Promise<IFailedRecord<T> | undefined> => {
    const db = await dbPromise;
    return db.get(FAILED_RECORDS_TABLE, id);
  },

  getByJobId: async <T>(jobId: string): Promise<IFailedRecord<T>[]> => {
    const db = await dbPromise;
    return db.getAllFromIndex(FAILED_RECORDS_TABLE, 'jobId', jobId) as Promise<IFailedRecord<T>[]>;
  },

  deleteById: async (id: string): Promise<void> => {
    const db = await dbPromise;
    await db.delete(FAILED_RECORDS_TABLE, id);
  },

  clearByJobId: async (jobId: string): Promise<void> => {
    const db = await dbPromise;
    const records = await db.getAllFromIndex(FAILED_RECORDS_TABLE, 'jobId', jobId);
    const tx = db.transaction(FAILED_RECORDS_TABLE, 'readwrite');
    for (const r of records) {
      tx.store.delete(r.id);
    }
    await tx.done;
  },
};
